import toast from "react-hot-toast";
import {
  SHOPPER_ADD,
  SHOPPER_ADD_FAIL,
  SHOPPER_ADD_SUCCESS,
  SHOPPER_LIST,
  SHOPPER_LIST_FAIL,
  SHOPPER_LIST_SUCCESS,
  PERSONAL_SHOPPER_LIST,
  PERSONAL_SHOPPER_LIST_FAIL,
  PERSONAL_SHOPPER_LIST_SUCCESS,
  SHOPPER_DETAIL,
  SHOPPER_DETAIL_FAIL,
  SHOPPER_DETAIL_SUCCESS,
  SHOPPER_ROLE_LIST,
  SHOPPER_ROLE_LIST_FAIL,
  SHOPPER_ROLE_LIST_SUCCESS,
  SHOPPER_STATUS_CHANGE,
  SHOPPER_STATUS_CHANGE_FAIL,
  SHOPPER_STATUS_CHANGE_SUCCESS,
} from "../../actions/admin/customer-actions";

const initialState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
  shopperListStatistics: {},
  totalPages: 0,
  total: 0,
  shopperList: [],
  personalShopperList: [],
  personalShopperTotal: 0,
  shopperDetail: null,
  shopperDetailLoading: false,
  shopperDetailError: null,
  shopperRoles: [],
};

const shopperReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PERSONAL_SHOPPER_LIST: {
      return { ...state, isLoading: true, personalShopperList: [] };
    }

    case PERSONAL_SHOPPER_LIST_SUCCESS: {
      const listData = Array.isArray(payload.data)
        ? payload.data
        : payload.data?.data || payload.data?.list || [];
      return {
        ...state,
        personalShopperList: listData,
        personalShopperTotal: payload.data?.total || payload.data?.totalCount || listData.length || 0,
        isLoading: false,
      };
    }

    case PERSONAL_SHOPPER_LIST_FAIL: {
      return { ...state, isLoading: false };
    }

    case SHOPPER_DETAIL: {
      return {
        ...state,
        shopperDetailLoading: true,
        shopperDetailError: null,
        shopperDetail: null,
      };
    }

    case SHOPPER_DETAIL_SUCCESS: {
      return {
        ...state,
        shopperDetail: payload?.data?.id ? payload.data : null,
        shopperDetailLoading: false,
        shopperDetailError: null,
      };
    }

    case SHOPPER_DETAIL_FAIL: {
      const message =
        payload?.error?.data?.message ||
        payload?.error?.message ||
        "Failed to load shopper";
      return {
        ...state,
        shopperDetailLoading: false,
        shopperDetailError: message,
      };
    }

    case SHOPPER_LIST: {
      return {
        ...state,
        isLoading: true,
        shopperList: [],
      };
    }

    case SHOPPER_LIST_SUCCESS: {
      const listData = Array.isArray(payload.data)
        ? payload.data
        : payload.data?.data || payload.data?.list || [];

      return {
        ...state,
        shopperList: listData,
        shopperListStatistics: payload.data?.shopperCount || payload.data?.count || {},
        total: payload.data?.total || payload.data?.totalCount || listData.length || 0,
        totalPages: payload.data?.totalPages || 0,
        isLoading: false,
      };
    }

    case SHOPPER_LIST_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case SHOPPER_ADD: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case SHOPPER_ADD_SUCCESS: {
      toast.success(payload.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case SHOPPER_ADD_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case SHOPPER_ROLE_LIST: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case SHOPPER_ROLE_LIST_SUCCESS: {
      return {
        ...state,
        shopperRoles: payload.data?.data || payload.data || [],
        isLoading: false,
      };
    }

    case SHOPPER_ROLE_LIST_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case SHOPPER_STATUS_CHANGE: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case SHOPPER_STATUS_CHANGE_SUCCESS: {
      toast.success(payload.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    case SHOPPER_STATUS_CHANGE_FAIL: {
      toast.error(payload.error?.data?.message);
      return {
        ...state,
        isLoading: false,
      };
    }

    default: {
      return { ...state };
    }
  }
};

export default shopperReducer;
